export class PartnerRfpRequestDTO {
    id: number;
    projectName: string;
    name: string;
    submissionDateStart: Date | null;
    submissionDateEnd: Date | null;
    creationDateStart: Date | null;
    creationDateEnd: Date | null;
    businessTypeIDs: number[];
    telNumber: string;
    gstNumber: string;
    address: string;
    address2: string;
    email: string;
    description: string;
    status: number | null;
    clickId: string;
    languageID: number | string;
    utmSource: string;
    regions: number[];
    dateStartCreationYYYYMMDD: string;
    dateEndCreationYYYYMMDD: string;
    dateSubmissionYYYYMM: string | null;
    userId: number | string;
    rejectReasons: number[];
    remoteId: string;
    remoteSource: string;
    zipCodes: string[];
    operatorIds: number[];
    affiliateIds: number[];
    statusList: number[];
    statusNotIn : number[];
    boStatus: number | null;
    cannotContact: number | null;
    isLeadPlus: boolean | null;
    isPriority: boolean | null;

    constructor(data?: any) {
        this.id = data?.id ?? "";
        this.projectName = data?.projectName ?? "";
        this.name = data?.name ?? "";
        this.submissionDateStart = data?.submissionDateStart ?? null;
        this.submissionDateEnd = data?.submissionDateEnd ?? null;
        this.creationDateStart = data?.creationDateStart ?? null;
        this.creationDateEnd = data?.creationDateEnd ?? null;
        this.businessTypeIDs = data?.businessTypeIDs ?? [];
        this.telNumber = data?.telNumber ?? "";
        this.gstNumber = data?.gstNumber ?? "";
        this.address = data?.address ?? "";
        this.address2 = data?.address2 ?? "";
        this.email = data?.email ?? "";
        this.description = data?.description ?? "";
        this.status = data?.status ?? null;
        this.clickId = data?.clickId ?? "";
        this.languageID = data?.languageID ?? "";
        this.utmSource = data?.utmSource ?? "";
        this.regions = data?.regions ?? [];
        this.dateStartCreationYYYYMMDD = data?.dateStartCreationYYYYMMDD ?? "";
        this.dateEndCreationYYYYMMDD = data?.dateEndCreationYYYYMMDD ?? "";
        this.dateSubmissionYYYYMM = data?.dateSubmissionYYYYMM ?? null;
        this.userId = data?.userId ?? "";
        this.rejectReasons = data?.rejectReasons ?? [];
        this.remoteId = data?.remoteId ?? "";
        this.remoteSource = data?.remoteSource ?? "";
        this.zipCodes = data?.zipCodes ?? [];
        this.operatorIds = data?.operatorIds ?? [];
        this.affiliateIds = data?.affiliateIds ?? [];
        this.statusList = data?.statusList ?? [];
        this.statusNotIn  = data?.statusNotIn ?? [];
        this.boStatus = data?.boStatus ?? null;
        this.cannotContact = data?.cannotContact ?? null;
        this.isLeadPlus = data?.isLeadPlus ?? null;
        this.isPriority = data?.isPriority ?? null;
    }

}